// extracted by mini-css-extract-plugin
export var fileUpload = "_j2-1";
export var modalButton = "_j2-0";